// Data for local landing pages (/toemrer-hoejbjerg, /toemrer-viby, /toemrer-skanderborg, /toemrer-maarslet, /toemrer-odder)
// Each page matches verbatim content, meta tags, FAQ structure, and schema markup.

export const LOCAL_PAGES = {
  "toemrer-hoejbjerg": {
    slug: "toemrer-hoejbjerg",
    path: "/toemrer-hoejbjerg",
    cityName: "Højbjerg",
    seo: {
      title_tag: "Tømrer i Højbjerg | Få personlig hjælp fra start til slut",
      meta_description: "Vælg en erfaren tømrer i Højbjerg med over 20 års erfaring. Få direkte kontakt, solidt håndværk og personlig hjælp til ombygning og totalrenovering."
    },
    h1: "Tømrer i Højbjerg med personlig hjælp til små og store opgaver",
    intro: "Har du brug for en tømrer i Højbjerg til en mindre opgave eller en større ændring af boligen, hjælper jeg med solidt tømrerarbejde og løsninger, der passer til huset. Jeg hedder Søren Sehested, har over 20 års erfaring og er din direkte kontakt gennem arbejdet.",
    sections: [
      {
        h2: "Få samme tømrermester fra første samtale til færdigt arbejde",
        paragraphs: [
          "Når du vælger Sehested Tømrerfirma, er det mig, du taler med, og mig, der udfører tømrerarbejdet. Du undgår skiftende kontaktpersoner og unødige mellemled. Det gør det lettere at holde fast i dine ønsker og få afklaret spørgsmål undervejs i projektet.",
          "Mit tømrerfirma har base i Hasselager, og jeg løser opgaver for boligejere i Højbjerg og resten af Aarhus Syd. Som erfaren tømrermester lægger jeg vægt på en ligefrem dialog, grundig udførelse og løsninger, der tager udgangspunkt i den konkrete bolig."
        ]
      },
      {
        h2: "Hvilket tømrerarbejde kan jeg hjælpe med i Højbjerg",
        paragraphs: [
          "Jeg hjælper med både enkelte forbedringer og sammenhængende byggeprojekter. Det kan være alt fra montering af døre og vinduer til tagarbejde, træterrasse, tilbygning, ombygning og totalrenovering. Opgavens størrelse ændrer ikke behovet for præcision og klare aftaler."
        ],
        list: [
          "Ombygning af bolig og ændring af rum",
          "Totalrenovering af hus eller større dele af boligen",
          "Tilbygning tilpasset den eksisterende bolig",
          "Træterrasser tilpasset boligen og udearealet",
          "Døre og vinduer, herunder specialfremstillede løsninger",
          "Tagarbejde og øvrige tømreropgaver"
        ],
        afterListParagraph: "Har du en særlig løsning i tankerne, ser jeg på, hvordan den kan udføres i praksis. Jeg har blandt andet erfaring med levering og præcis montering af specialfremstillede vinduer fra Horn Vinduesfabrik. Det er et eksempel på tømrerarbejde, hvor opmåling og detaljer har stor betydning."
      },
      {
        h2: "Når ombygning i Højbjerg skal give boligen mere mening",
        paragraphs: [
          "Ved en ombygning ændrer du ofte boligens indretning eller funktion, mens en renovering typisk opdaterer det eksisterende. Det kan være en ny rumfordeling, ombygning af køkken, ændringer omkring taget eller en bredere ombygning af huset. Målet er, at pladsen fungerer bedre i hverdagen."
        ],
        subsections: [
          {
            h3: "Start med behovene og husets muligheder",
            paragraphs: [
              "En vellykket ombygning i Højbjerg begynder med at få styr på behov, rammer og de dele af boligen, der skal bevares. Jeg tager udgangspunkt i, hvordan du bruger huset nu, og hvad du ønsker at ændre. Derefter kan materialer og praktiske løsninger vurderes på et mere realistisk grundlag."
            ]
          },
          {
            h3: "Hvad koster en ombygning",
            paragraphs: [
              "Prisen på en ombygning afhænger blandt andet af omfang, materialevalg, boligens stand og behovet for ændringer i konstruktionen. Derfor giver en generel kvadratmeterpris sjældent et retvisende svar. En konkret gennemgang gør det lettere at afgrænse arbejdet og prioritere budgettet."
            ]
          }
        ]
      },
      {
        h2: "Totalrenovering i Højbjerg med blik for helheden",
        paragraphs: [
          "En totalrenovering samler flere renoveringsopgaver i et større forløb. Det kan være relevant, når mange dele af boligen skal opdateres, eller når et ældre hus skal tilpasses nye behov. Ved totalrenovering i Højbjerg ser jeg på sammenhængen mellem løsningerne frem for kun den enkelte detalje.",
          "Indholdet kan variere fra bolig til bolig og kan blandt andet omfatte døre, vinduer, tagarbejde og ændringer i boligens indretning. Hvad der skal udføres, aftales ud fra huset og dine ønsker. Det er også afgørende for prisen på en totalrenovering, som kræver et konkret omfang."
        ]
      },
      {
        h2: "Er totalentreprise den rette løsning til dit projekt",
        paragraphs: [
          "En totalentreprise kan være relevant, når et byggeprojekt rummer flere dele og har brug for en samlet ramme. Hos Sehested Tømrerfirma bliver det konkrete indhold af totalentreprisen afklaret ud fra projektet. På den måde ved du, hvilke arbejder og aftaler der indgår, før løsningen lægges fast.",
          "Totalentreprise kan blandt andet komme i spil ved en omfattende renovering, ombygning eller tilbygning. Entrepriseformen skal passe til opgaven, og derfor starter jeg med at lytte til dine planer og vurdere tømrerarbejdet. Så får vi et sagligt udgangspunkt for det videre forløb."
        ]
      },
      {
        h2: "Fortæl mig om din tømreropgave i Højbjerg",
        paragraphs: [
          "Søger du et lokalt tømrerfirma til ombygning, totalrenovering eller andet tømrerarbejde i Højbjerg, er du velkommen til at kontakte mig. Fortæl kort om boligen og dine ønsker, så kan vi tage en faglig snak om mulighederne og finde ud af, om jeg er den rette tømrer til opgaven."
        ]
      }
    ],
    faq: [
      {
        question: "Hvilke typer tømrerarbejde kan en tømrer hjælpe med?",
        answer: "Sehested Tømrerfirma udfører både små og store tømreropgaver, herunder ombygning, totalrenovering, tilbygning, træterrasser, montering af døre og vinduer samt tagarbejde. Som lokal tømrer i Højbjerg tilpasses løsningen til den konkrete bolig og kundens ønsker."
      },
      {
        question: "Får man samme tømrermester fra første samtale til færdigt arbejde?",
        answer: "Hos Sehested Tømrerfirma står Søren Sehested selv for dialogen og udførelsen af arbejdet fra start til slut. Det giver direkte kontakt til en tømrermester med over 20 års erfaring og mindsker risikoen for mellemled og misforståelser."
      },
      {
        question: "Hvad er forskellen på ombygning og renovering?",
        answer: "En ombygning ændrer typisk boligens indretning eller funktion, eksempelvis rumfordelingen eller køkkenets opbygning, mens en renovering opdaterer eksisterende dele. Ved ombygning i Højbjerg tager Sehested Tømrerfirma udgangspunkt i kundens behov, husets muligheder og de dele, der skal bevares."
      },
      {
        question: "Hvad koster en ombygning?",
        answer: "Prisen afhænger blandt andet af projektets omfang, materialevalg, boligens stand og eventuelle ændringer i konstruktionen. Sehested Tømrerfirma vurderer derfor den konkrete opgave, så arbejdet kan afgrænses, og budgettet kan prioriteres på et realistisk grundlag."
      },
      {
        question: "Hvad kan indgå i en totalrenovering?",
        answer: "En totalrenovering kan samle flere arbejder som nye døre og vinduer, tagarbejde og ændringer af boligens indretning. Ved totalrenovering i Højbjerg ser Sehested Tømrerfirma på sammenhængen mellem løsningerne og aftaler indholdet ud fra husets stand og kundens ønsker."
      },
      {
        question: "Hvornår er totalentreprise relevant?",
        answer: "Totalentreprise kan være relevant, når en omfattende renovering, ombygning eller tilbygning består af flere dele og kræver en samlet ramme. Hos Sehested Tømrerfirma afklares det konkret, hvilke arbejder og aftaler der skal indgå, før løsningen fastlægges."
      },
      {
        question: "Kan en tømrer montere specialfremstillede vinduer?",
        answer: "Ja. Sehested Tømrerfirma har erfaring med levering og præcis montering af specialfremstillede vinduer fra Horn Vinduesfabrik. Ved denne type tømrerarbejde lægges der særlig vægt på korrekt opmåling, detaljer og tilpasning til boligen."
      }
    ],
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvilke typer tømrerarbejde kan en tømrer hjælpe med?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sehested Tømrerfirma udfører både små og store tømreropgaver, herunder ombygning, totalrenovering, tilbygning, træterrasser, montering af døre og vinduer samt tagarbejde. Som lokal tømrer i Højbjerg tilpasses løsningen til den konkrete bolig og kundens ønsker."
          }
        },
        {
          "@type": "Question",
          "name": "Får man samme tømrermester fra første samtale til færdigt arbejde?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Hos Sehested Tømrerfirma står Søren Sehested selv for dialogen og udførelsen af arbejdet fra start til slut. Det giver direkte kontakt til en tømrermester med over 20 års erfaring og mindsker risikoen for mellemled og misforståelser."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad er forskellen på ombygning og renovering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En ombygning ændrer typisk boligens indretning eller funktion, eksempelvis rumfordelingen eller køkkenets opbygning, mens en renovering opdaterer eksisterende dele. Ved ombygning i Højbjerg tager Sehested Tømrerfirma udgangspunkt i kundens behov, husets muligheder og de dele, der skal bevares."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad koster en ombygning?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prisen afhænger blandt andet af projektets omfang, materialevalg, boligens stand og eventuelle ændringer i konstruktionen. Sehested Tømrerfirma vurderer derfor den konkrete opgave, så arbejdet kan afgrænses, og budgettet kan prioriteres på et realistisk grundlag."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad kan indgå i en totalrenovering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En totalrenovering kan samle flere arbejder som nye døre og vinduer, tagarbejde og ændringer af boligens indretning. Ved totalrenovering i Højbjerg ser Sehested Tømrerfirma på sammenhængen mellem løsningerne og aftaler indholdet ud fra husets stand og kundens ønsker."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår er totalentreprise relevant?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Totalentreprise kan være relevant, når en omfattende renovering, ombygning eller tilbygning består af flere dele og kræver en samlet ramme. Hos Sehested Tømrerfirma afklares det konkret, hvilke arbejder og aftaler der skal indgå, før løsningen fastlægges."
          }
        },
        {
          "@type": "Question",
          "name": "Kan en tømrer montere specialfremstillede vinduer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ja. Sehested Tømrerfirma har erfaring med levering og præcis montering af specialfremstillede vinduer fra Horn Vinduesfabrik. Ved denne type tømrerarbejde lægges der særlig vægt på korrekt opmåling, detaljer og tilpasning til boligen."
          }
        }
      ]
    }
  },

  "toemrer-viby": {
    slug: "toemrer-viby",
    path: "/toemrer-viby",
    cityName: "Viby",
    seo: {
      title_tag: "Tømrer i Viby | Få samme fagmand fra start til slut",
      meta_description: "Vælg en erfaren tømrer i Viby til totalrenovering og ombygning. Få personlig kontakt, solidt håndværk og samme fagmand gennem hele projektet."
    },
    h1: "Tømrer i Viby med personlig kontakt og solidt håndværk",
    intro: "Søger du en tømrer i Viby, får du hos Sehested Tømrerfirma en erfaren fagperson, som følger dit projekt fra den første samtale til det færdige resultat. Jeg hedder Søren Sehested, har over 20 års erfaring og udfører selv arbejdet, så du har direkte kontakt uden unødige mellemled.",
    sections: [
      {
        h2: "Tømrerarbejde i Viby, fra mindre opgaver til større løsninger",
        paragraphs: [
          "Mit tømrerfirma har base i Hasselager, og jeg løser opgaver for kunder i Viby og resten af Aarhus Syd. Det giver dig en lokal løsning med kort vej til dialogen. Jeg udfører både afgrænsede opgaver og større projekter, hvor flere dele af boligen skal tænkes sammen.",
          "Du kan blandt andet få hjælp til tilbygning, træterrasse, døre og vinduer samt tagarbejde. Fælles for opgaverne er, at løsningen bliver tilpasset huset og dine ønsker. Som tømrermester lægger jeg vægt på præcis udførelse og detaljer, der fungerer i dagligdagen."
        ],
        list: [
          "Totalrenovering af hele eller dele af boligen",
          "Ombygning og tilbygning til nye behov",
          "Træterrasser tilpasset bolig og udeareal",
          "Montering af døre og vinduer",
          "Tagarbejde og øvrige tømreropgaver"
        ]
      },
      {
        h2: "Totalrenovering i Viby, sådan skaber vi en klar retning",
        paragraphs: [
          "Ved en totalrenovering i Viby handler det ikke kun om at forny enkelte overflader. Boligens rum, materialer og praktiske behov skal ses som en helhed. Jeg tager udgangspunkt i det eksisterende hus og taler med dig om, hvad der skal bevares, ændres eller bygges op på ny.",
          "Prisen på en totalrenovering afhænger blandt andet af boligens stand, projektets omfang, materialevalg og behovet for andre håndværksfag. Derfor giver en konkret gennemgang et mere retvisende grundlag end en generel kvadratmeterpris, uanset om hele huset eller udvalgte rum skal fornyes."
        ],
        subsections: [
          {
            h3: "Hvad skal du have afklaret før arbejdet begynder",
            paragraphs: [
              "En god start kræver, at ønsker og prioriteringer bliver gjort konkrete. Vi ser på, hvordan boligen bruges i dag, hvad der ikke fungerer, og hvilke forbedringer der betyder mest for dig. På den måde bliver det lettere at træffe valg om løsning, materialer og rækkefølge."
            ]
          }
        ]
      },
      {
        h2: "Ombygning i Viby, når indretningen skal fungere bedre",
        paragraphs: [
          "En ombygning i Viby kan være relevant, når boligen har de nødvendige kvadratmeter, men ikke den rigtige rumfordeling. Det kan også være, at køkkenet skal ændres, eller at huset skal åbnes mere mod terrasse og have. Jeg hjælper med at omsætte dine behov til praktisk tømrerarbejde.",
          "Ved renovering og ombygning ser jeg både på det synlige resultat og på de konstruktioner, som løsningen afhænger af. Ændringer skal passe til huset og udføres i en fornuftig rækkefølge. Derfor taler vi opgaven igennem, før materialer og udførelse bliver lagt fast."
        ]
      },
      {
        h2: "Kan totalentreprise gøre dit byggeprojekt mere overskueligt",
        paragraphs: [
          "Totalentreprise kan være relevant ved større renoveringsopgaver, ombygning eller tilbygning, hvor projektet består af flere dele. Som entrepriseform kan den samle forløbet og skabe et tydeligt ansvar. Hos Sehested Tømrerfirma bliver det konkrete omfang altid afklaret ud fra den enkelte opgave.",
          "Det er vigtigt at få klarhed over, hvad aftalen omfatter, før projektet går i gang. Vi gennemgår derfor behov, forventninger og de dele af byggeriet, som skal indgå. Så ved du, hvad der er aftalt, og du får et bedre grundlag for at følge processen fra start til slut."
        ],
        subsections: [
          {
            h3: "Samme tømrer fra start til slut",
            paragraphs: [
              "Når du vælger mig som din tømrer i Viby, er det mig, du taler med, og mig, der står med værktøjet i hånden. Det giver kontinuitet gennem hele opgaven og mindsker risikoen for, at vigtige detaljer går tabt mellem flere kontaktpersoner. Du ved med andre ord, hvem der har ansvaret for udførelsen.",
              "Jeg tror på, at det gode resultat begynder med en ærlig og konkret samtale om mulighederne i din bolig. Nogle ønsker kræver en større løsning, mens andre kan løses mere enkelt. Min opgave er at bruge min erfaring til at finde en løsning, der passer til huset og det, du vil opnå."
            ]
          }
        ]
      },
      {
        h2: "Få en faglig snak om din bolig i Viby",
        paragraphs: [
          "Har du brug for et erfarent tømrerfirma til tømrerarbejde, ombygning, totalrenovering eller totalentreprise i Viby, er du velkommen til at kontakte Sehested Tømrerfirma. Fortæl mig om boligen og dine planer, så tager vi en konkret snak om opgaven og om, hvordan næste skridt kan se ud."
        ]
      }
    ],
    faq: [
      {
        question: "Hvilke opgaver kan en tømrer hjælpe med?",
        answer: "Sehested Tømrerfirma udfører tømrerarbejde som totalrenovering, ombygning, tilbygning, træterrasser, montering af døre og vinduer samt tagarbejde. Som tømrer i Viby tilpasser Søren Sehested løsningen til boligen, udearealet og kundens ønsker."
      },
      {
        question: "Hvad koster en totalrenovering?",
        answer: "Prisen på en totalrenovering afhænger blandt andet af boligens stand, projektets omfang, materialevalg og behovet for andre håndværksfag. Ved totalrenovering i Viby gennemgår Sehested Tømrerfirma derfor boligen og opgaven konkret, da det giver et mere retvisende grundlag end en generel kvadratmeterpris."
      },
      {
        question: "Hvad bør afklares før en totalrenovering begynder?",
        answer: "Før arbejdet begynder, bør det afklares, hvordan boligen bruges, hvad der ikke fungerer, og hvilke dele der skal bevares, ændres eller bygges op på ny. Sehested Tømrerfirma gennemgår ønsker, prioriteringer, materialer og rækkefølge, så projektet får en klar retning."
      },
      {
        question: "Hvornår er en ombygning en god løsning?",
        answer: "En ombygning kan være relevant, når boligen har plads nok, men rumfordelingen ikke passer til de aktuelle behov. Ved ombygning i Viby hjælper Sehested Tømrerfirma eksempelvis med ændringer af køkken, indretning eller åbninger mod terrasse og have, mens der samtidig tages hensyn til husets konstruktioner."
      },
      {
        question: "Hvordan fungerer totalentreprise ved et byggeprojekt?",
        answer: "Totalentreprise kan gøre større renoveringer, ombygninger og tilbygninger mere overskuelige ved at samle forløbet og skabe et tydeligt ansvar. Hos Sehested Tømrerfirma bliver behov, forventninger og det konkrete omfang gennemgået, før arbejdet sættes i gang, så det er klart, hvilke dele aftalen omfatter."
      },
      {
        question: "Hvorfor vælge den samme tømrermester fra start til slut?",
        answer: "Når den samme tømrermester følger projektet gennem hele forløbet, bliver kontakten mere direkte, og risikoen for tabte detaljer mellem flere kontaktpersoner mindskes. Hos Sehested Tømrerfirma står Søren Sehested selv for dialogen og udførelsen med over 20 års erfaring, så kunden har én fast fagperson gennem opgaven."
      }
    ],
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvilke opgaver kan en tømrer hjælpe med?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sehested Tømrerfirma udfører tømrerarbejde som totalrenovering, ombygning, tilbygning, træterrasser, montering af døre og vinduer samt tagarbejde. Som tømrer i Viby tilpasser Søren Sehested løsningen til boligen, udearealet og kundens ønsker."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad koster en totalrenovering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prisen på en totalrenovering afhænger blandt andet af boligens stand, projektets omfang, materialevalg og behovet for andre håndværksfag. Ved totalrenovering i Viby gennemgår Sehested Tømrerfirma derfor boligen og opgaven konkret, da det giver et mere retvisende grundlag end en generel kvadratmeterpris."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad bør afklares før en totalrenovering begynder?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Før arbejdet begynder, bør det afklares, hvordan boligen bruges, hvad der ikke fungerer, og hvilke dele der skal bevares, ændres eller bygges op på ny. Sehested Tømrerfirma gennemgår ønsker, prioriteringer, materialer og rækkefølge, så projektet får en klar retning."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår er en ombygning en god løsning?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En ombygning kan være relevant, når boligen har plads nok, men rumfordelingen ikke passer til de aktuelle behov. Ved ombygning i Viby hjælper Sehested Tømrerfirma eksempelvis med ændringer af køkken, indretning eller åbninger mod terrasse og have, mens der samtidig tages hensyn til husets konstruktioner."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan fungerer totalentreprise ved et byggeprojekt?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Totalentreprise kan gøre større renoveringer, ombygninger og tilbygninger mere overskuelige ved at samle forløbet og skabe et tydeligt ansvar. Hos Sehested Tømrerfirma bliver behov, forventninger og det konkrete omfang gennemgået, før arbejdet sættes i gang, så det er klart, hvilke dele aftalen omfatter."
          }
        },
        {
          "@type": "Question",
          "name": "Hvorfor vælge den samme tømrermester fra start til slut?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Når den samme tømrermester følger projektet gennem hele forløbet, bliver kontakten mere direkte, og risikoen for tabte detaljer mellem flere kontaktpersoner mindskes. Hos Sehested Tømrerfirma står Søren Sehested selv for dialogen og udførelsen med over 20 års erfaring, så kunden har én fast fagperson gennem opgaven."
          }
        }
      ]
    }
  },

  "toemrer-skanderborg": {
    slug: "toemrer-skanderborg",
    path: "/toemrer-skanderborg",
    cityName: "Skanderborg",
    seo: {
      title_tag: "Tømrer i Skanderborg | Få samme fagmand hele vejen",
      meta_description: "Vælg en erfaren tømrer i Skanderborg med over 20 års erfaring. Få direkte dialog fra start til slut om ombygning, totalrenovering og totalentreprise."
    },
    h1: "Tømrer i Skanderborg med samme fagperson fra start til slut",
    intro: "Søger du en tømrer i Skanderborg, som du kan tale direkte med gennem hele opgaven? Hos Sehested Tømrerfirma møder du mig, Søren Sehested. Jeg har over 20 års erfaring med tømrerarbejde, og jeg kører fra min base i Hasselager til både mindre opgaver og større byggeprojekter i Skanderborg.",
    sections: [
      {
        h2: "Hvilket tømrerarbejde kan jeg hjælpe med i Skanderborg?",
        paragraphs: [
          "Jeg udfører tømrerarbejde, der tager udgangspunkt i din bolig og det, du gerne vil ændre. Det kan være en afgrænset opgave med nye døre og vinduer, en træterrasse eller tagarbejde. Jeg hjælper også, når boligen skal have en tilbygning eller en mere omfattende forandring.",
          "Før arbejdet går i gang, taler vi om dine ønsker og de praktiske forhold omkring opgaven. Materialer, husets eksisterende udtryk og den ønskede anvendelse har betydning for løsningen. På den måde bliver arbejdet tilpasset boligen frem for presset ned i en standardløsning."
        ],
        list: [
          "Tilbygning til boligens eksisterende rammer",
          "Træterrasse til hus og have",
          "Udskiftning og montering af døre og vinduer",
          "Tagarbejde på boligen",
          "Renoveringsopgaver i forskelligt omfang"
        ],
        subsections: [
          {
            h3: "Døre, vinduer og tagarbejde med fokus på detaljen",
            paragraphs: [
              "Ved arbejde med døre og vinduer er præcis opmåling og montering afgørende for både udtryk og funktion. Jeg har blandt andet leveret og monteret specialfremstillede vinduer fra Horn Vinduesfabrik i et konkret projekt, hvor tilpasning og omhyggelig montering var centrale dele af opgaven."
            ]
          },
          {
            h3: "En træterrasse eller tilbygning skal passe til hverdagen",
            paragraphs: [
              "En træterrasse skal fungere som en naturlig del af huset og haven, mens en tilbygning skal give de ekstra kvadratmeter eller funktioner, du mangler. Jeg ser på sammenhængen mellem den eksisterende bolig og det nye, så materialer, proportioner og anvendelse bliver tænkt ind i den konkrete tømreropgave."
            ]
          }
        ]
      },
      {
        h2: "Overvejer du ombygning, totalrenovering eller totalentreprise?",
        paragraphs: [
          "En ombygning er relevant, når du vil ændre boligens indretning eller bruge pladsen på en ny måde. Ved en totalrenovering er flere dele af huset typisk i spil på samme tid. Begge typer projekter kræver, at ønsker og eksisterende forhold bliver gennemgået, før løsningen fastlægges.",
          "Det kan eksempelvis handle om en ny rumfordeling, udskiftning af bygningsdele eller en samlet modernisering af boligen. Som tømrer bidrager jeg med et praktisk og fagligt blik på, hvad der kan udføres, og hvordan de forskellige dele bør hænge sammen i det færdige resultat."
        ],
        list: [
          "Hvordan rummene skal bruges i hverdagen",
          "Hvilke dele af boligen der skal ændres",
          "Hvilke materialer der passer til huset",
          "Hvor omfattende projektet skal være"
        ],
        subsections: [
          {
            h3: "Hvordan kan en ombygning give boligen bedre sammenhæng?",
            paragraphs: [
              "Ved ombygning af hus er flere kvadratmeter ikke altid svaret. En ændret planløsning kan i nogle boliger skabe bedre forbindelser mellem køkken, stue og opholdsrum eller give plads til nye behov. Mulighederne afhænger af husets konstruktion, og derfor skal løsningen vurderes ud fra den enkelte bolig."
            ]
          },
          {
            h3: "Hvad betyder totalentreprise for din konkrete opgave?",
            paragraphs: [
              "Jeg tilbyder totalentreprise til større byggeprojekter, men indholdet skal altid passe til den konkrete sag. Derfor afklarer vi først projektets omfang, dine forventninger og de dele, der skal indgå. Du får dermed en tydeligere forståelse af rammen, før arbejdet bliver sat i gang.",
              "Ved totalrenovering eller ombygning kan der være mange valg, som påvirker hinanden. Her er det vigtigt at få prioriteret behovene og undersøgt boligens forhold tidligt. Jeg lover ikke en standardpakke, men tager udgangspunkt i det projekt, du faktisk står med i Skanderborg."
            ]
          }
        ]
      },
      {
        h2: "Hvad koster en tømrer i Skanderborg?",
        paragraphs: [
          "Prisen på tømrerarbejde afhænger blandt andet af opgavens størrelse, materialevalg, adgangsforhold og boligens nuværende stand. En mindre udskiftning kan derfor ikke vurderes på samme måde som en totalrenovering eller en ombygning. En konkret beskrivelse giver det bedste grundlag for en vurdering.",
          "Når du kontakter mig, er det en hjælp at fortælle, hvad du vil have lavet, hvor i boligen arbejdet skal udføres, og om du allerede har valgt materialer. Billeder og relevante mål kan også gøre den første dialog mere præcis, men den endelige vurdering afhænger altid af den konkrete opgave."
        ],
        subsections: [
          {
            h3: "Samme tømrermester giver dig en direkte dialog",
            paragraphs: [
              "Som tømrermester står jeg selv for kontakten og det praktiske arbejde fra start til slut. Du skal ikke forklare dine ønsker til skiftende personer, og der er ingen mellemled mellem vores samtale og arbejdet på boligen. Det giver en enkel og personlig kontakt gennem hele tømreropgaven."
            ]
          }
        ]
      },
      {
        h2: "Skal vi tale om din tømreropgave i Skanderborg?",
        paragraphs: [
          "Uanset om du søger et tømrerfirma til tagarbejde, nye vinduer, en træterrasse eller et større projekt, er du velkommen til at kontakte mig. Fortæl kort om dine planer, så tager vi en faglig snak om mulighederne. Du får kontakt med mig, Søren Sehested, fra første samtale."
        ]
      }
    ],
    faq: [
      {
        question: "Hvilket tømrerarbejde kan et tømrerfirma hjælpe med?",
        answer: "For kunder, der søger en tømrer i Skanderborg, udfører Sehested Tømrerfirma både mindre og større tømrerarbejde. Det omfatter blandt andet tilbygning, træterrasse, udskiftning og montering af døre og vinduer, tagarbejde samt forskellige renoveringsopgaver."
      },
      {
        question: "Hvad koster en tømrer?",
        answer: "Prisen på en tømrer afhænger blandt andet af opgavens størrelse, materialevalg, adgangsforhold og boligens nuværende stand. Sehested Tømrerfirma vurderer derfor opgaven konkret. En beskrivelse af arbejdet samt billeder, mål og eventuelle materialevalg kan gøre den første dialog mere præcis."
      },
      {
        question: "Hvornår er en ombygning eller totalrenovering den rette løsning?",
        answer: "En ombygning er relevant, når boligens indretning eller anvendelse skal ændres, eksempelvis gennem en ny rumfordeling. Ved en totalrenovering er flere dele af huset typisk i spil samtidig. Sehested Tømrerfirma gennemgår ønsker, eksisterende forhold, materialer og projektets omfang, før løsningen fastlægges."
      },
      {
        question: "Hvad betyder totalentreprise ved et større byggeprojekt?",
        answer: "Sehested Tømrerfirma tilbyder totalentreprise til større byggeprojekter. Før arbejdet begynder, bliver projektets omfang, forventninger og de dele, der skal indgå, afklaret. Det giver en tydeligere ramme for den konkrete opgave frem for en standardiseret løsning."
      },
      {
        question: "Hvad er vigtigt ved udskiftning af døre og vinduer?",
        answer: "Præcis opmåling og omhyggelig montering er afgørende for både funktion og udtryk. Sehested Tømrerfirma tilpasser arbejdet til boligens eksisterende forhold og har blandt andet erfaring med levering og montering af specialfremstillede vinduer."
      },
      {
        question: "Hvordan bliver en træterrasse eller tilbygning tilpasset boligen?",
        answer: "En træterrasse skal fungere som en naturlig del af huset og haven, mens en tilbygning skal skabe de ønskede kvadratmeter eller funktioner. Sehested Tømrerfirma ser derfor på materialer, proportioner, anvendelse og sammenhængen med den eksisterende bolig."
      },
      {
        question: "Hvorfor vælge den samme tømrermester fra start til slut?",
        answer: "Hos Sehested Tømrerfirma står tømrermester Søren Sehested selv for både kontakten og det praktiske arbejde. Med over 20 års erfaring sikrer han en direkte dialog uden skiftende kontaktpersoner eller mellemled gennem hele tømreropgaven."
      }
    ],
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvilket tømrerarbejde kan et tømrerfirma hjælpe med?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "For kunder, der søger en tømrer i Skanderborg, udfører Sehested Tømrerfirma både mindre og større tømrerarbejde. Det omfatter blandt andet tilbygning, træterrasse, udskiftning og montering af døre og vinduer, tagarbejde samt forskellige renoveringsopgaver."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad koster en tømrer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prisen på en tømrer afhænger blandt andet af opgavens størrelse, materialevalg, adgangsforhold og boligens nuværende stand. Sehested Tømrerfirma vurderer derfor opgaven konkret. En beskrivelse af arbejdet samt billeder, mål og eventuelle materialevalg kan gøre den første dialog mere præcis."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår er en ombygning eller totalrenovering den rette løsning?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En ombygning er relevant, når boligens indretning eller anvendelse skal ændres, eksempelvis gennem en ny rumfordeling. Ved en totalrenovering er flere dele af huset typisk i spil samtidig. Sehested Tømrerfirma gennemgår ønsker, eksisterende forhold, materialer og projektets omfang, før løsningen fastlægges."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad betyder totalentreprise ved et større byggeprojekt?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sehested Tømrerfirma tilbyder totalentreprise til større byggeprojekter. Før arbejdet begynder, bliver projektets omfang, forventninger og de dele, der skal indgå, afklaret. Det giver en tydeligere ramme for den konkrete opgave frem for en standardiseret løsning."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad er vigtigt ved udskiftning af døre og vinduer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Præcis opmåling og omhyggelig montering er afgørende for både funktion og udtryk. Sehested Tømrerfirma tilpasser arbejdet til boligens eksisterende forhold og har blandt andet erfaring med levering og montering af specialfremstillede vinduer."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan bliver en træterrasse eller tilbygning tilpasset boligen?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En træterrasse skal fungere som en naturlig del af huset og haven, mens en tilbygning skal skabe de ønskede kvadratmeter eller funktioner. Sehested Tømrerfirma ser derfor på materialer, proportioner, anvendelse og sammenhængen med den eksisterende bolig."
          }
        },
        {
          "@type": "Question",
          "name": "Hvorfor vælge den samme tømrermester fra start til slut?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Hos Sehested Tømrerfirma står tømrermester Søren Sehested selv for både kontakten og det praktiske arbejde. Med over 20 års erfaring sikrer han en direkte dialog uden skiftende kontaktpersoner eller mellemled gennem hele tømreropgaven."
          }
        }
      ]
    }
  },

  "toemrer-maarslet": {
    slug: "toemrer-maarslet",
    path: "/toemrer-maarslet",
    cityName: "Mårslet",
    seo: {
      title_tag: "Tømrer i Mårslet | Få personlig kontakt hele vejen",
      meta_description: "Få en erfaren tømrer i Mårslet med over 20 års erfaring og samme kontakt fra start til slut. Ring til Sehested Tømrerfirma og få en klar snak om dit projekt."
    },
    h1: "Tømrer i Mårslet med personlig kontakt hele vejen",
    intro: "Leder du efter en tømrer i Mårslet, som du kan tale direkte med gennem hele opgaven? Hos Sehested Tømrerfirma får du Søren Sehested som din faste kontakt og udførende tømrer. Jeg hjælper med både mindre opgaver og større boligprojekter, hvor solidt håndværk og klare aftaler er vigtige.",
    sections: [
      {
        h2: "Hvilket tømrerarbejde kan jeg hjælpe med i Mårslet?",
        paragraphs: [
          "Jeg har base i Hasselager og kører til boligejere i Mårslet og resten af Aarhus Syd. Med over 20 års erfaring inden for tømrerarbejde kan jeg rådgive ud fra boligens konstruktion, dine ønsker og opgavens omfang. Målet er en løsning, der passer til huset og den måde, du bruger det på.",
          "Når du vælger mit tømrerfirma, er det mig, du taler med, og mig, der står med værktøjet. Den direkte kontakt giver en enkel vej fra den første snak til det færdige tømrerarbejde. Det gør det lettere at afklare detaljer undervejs og begrænser risikoen for misforståelser."
        ],
        list: [
          "Ombygning og totalrenovering af boliger",
          "Tilbygning og totalentreprise efter projektets behov",
          "Træterrasser tilpasset hus og have",
          "Montering af døre og vinduer",
          "Tagarbejde og øvrigt tømrerarbejde"
        ],
        subsections: [
          {
            h3: "Døre, vinduer, tag og træterrasse tilpasset boligen",
            paragraphs: [
              "Jeg udfører blandt andet montering af døre og vinduer, hvor præcise mål og omhyggelig tilpasning har stor betydning for det samlede resultat. Jeg har også erfaring med levering og montering af specialfremstillede vinduer fra Horn Vinduesfabrik i forbindelse med et konkret projekt.",
              "Har du brug for tagarbejde, ser jeg på den konkrete opgave og boligens eksisterende konstruktion, før løsningen bliver fastlagt. En træterrasse bliver på samme måde tilpasset hus, have og ønsket anvendelse, så mål, materialer og udformning tænkes sammen fra begyndelsen."
            ]
          }
        ]
      },
      {
        h2: "Få overblik over ombygning og totalrenovering",
        paragraphs: [
          "En ombygning kan være relevant, når boligen har de nødvendige kvadratmeter, men rummene ikke længere fungerer i hverdagen. Det kan handle om en ændret rumfordeling, et køkken eller større forandringer i huset. Jeg hjælper med at gøre ønskerne konkrete og vurderer tømrerfagets del af projektet.",
          "Ved en totalrenovering skal mange valg passe sammen, og derfor er det vigtigt at få afgrænset opgaven tidligt. Prisen afhænger blandt andet af boligens stand, projektets størrelse, materialerne og eventuelle ændringer i konstruktionen. En konkret gennemgang giver derfor et mere brugbart grundlag end en generel pris."
        ],
        subsections: [
          {
            h3: "Hvornår giver totalentreprise mening?",
            paragraphs: [
              "En totalentreprise er en entrepriseform, hvor flere dele af et byggeprojekt normalt samles i én aftale. Den præcise organisering og ansvarsfordeling skal altid fremgå af den konkrete aftale. Hos mig bliver projektets indhold afklaret, før arbejdet begynder, så du ved, hvad min ydelse omfatter.",
              "Totalentreprise kan være relevant ved eksempelvis en større ombygning, tilbygning eller renovering, men entrepriseformen skal passe til projektet. Jeg lover derfor ikke en standardpakke. I stedet tager vi udgangspunkt i din bolig, de ønskede arbejder og de forhold, der skal undersøges nærmere."
            ]
          }
        ]
      },
      {
        h2: "Sådan får du et tydeligt byggeforløb",
        paragraphs: [
          "Et godt forløb begynder med, at du beskriver dine planer, prioriteringer og de udfordringer, du oplever i boligen. Herefter kan vi tale om muligheder, materialer og afgrænsning. Ved større renoveringsopgaver er en tydelig rækkefølge vigtig, fordi tidlige beslutninger ofte påvirker senere dele af byggeriet."
        ],
        list: [
          "Over 20 års erfaring med tømrerarbejde",
          "Samme kontaktperson fra start til slut",
          "Løsninger tilpasset boligens faktiske forhold",
          "Hjælp til både små og store opgaver"
        ],
        afterListParagraph: "Ældre huse kræver ofte mere end en pæn overflade. Ved ombygning og totalrenovering er det vigtigt at se på de eksisterende konstruktioner og på, hvordan nye løsninger møder det gamle hus. Derfor bliver dit projekt vurderet ud fra de faktiske forhold frem for en fast standardskabelon."
      },
      {
        h2: "Skal vi tale om din opgave i Mårslet?",
        paragraphs: [
          "Overvejer du nyt tag, vinduer, træterrasse, ombygning eller totalrenovering i Mårslet, er du velkommen til at fortælle mig om opgaven. Jo mere jeg ved om boligen og dine ønsker, desto bedre kan vi afklare, hvilke undersøgelser og løsninger der er relevante som næste skridt.",
          "Kontakt Sehested Tømrerfirma, hvis du søger en erfaren tømrermester tæt på Mårslet og ønsker direkte dialog med den person, der udfører arbejdet. Jeg tager gerne en indledende snak om både afgrænset tømrerarbejde og større projekter, så forventningerne kan blive afstemt fra begyndelsen."
        ]
      }
    ],
    faq: [
      {
        question: "Hvilket tømrerarbejde kan en erfaren tømrer hjælpe med?",
        answer: "Hos Sehested Tømrerfirma omfatter tømrerarbejde blandt andet ombygning, totalrenovering, tilbygning, totalentreprise, træterrasser, montering af døre og vinduer samt tagarbejde. Som tømrer i Mårslet hjælper Søren Sehested med både mindre opgaver og større boligprojekter."
      },
      {
        question: "Hvordan foregår et tømrerprojekt med en fast kontaktperson?",
        answer: "Når du vælger Sehested Tømrerfirma, er Søren Sehested både din faste kontakt og den udførende tømrermester fra start til slut. Det giver en direkte dialog om materialer, detaljer og ændringer undervejs og begrænser risikoen for misforståelser."
      },
      {
        question: "Hvornår giver en ombygning mening?",
        answer: "En ombygning kan være relevant, når boligen har plads nok, men rumfordelingen eller funktionerne ikke længere passer til hverdagen. Sehested Tømrerfirma hjælper med at konkretisere ønskerne og vurdere tømrerfagets del af eksempelvis en ændret rumfordeling, et køkken eller større forandringer i huset."
      },
      {
        question: "Hvad påvirker prisen på en totalrenovering?",
        answer: "Prisen på en totalrenovering afhænger blandt andet af boligens stand, projektets størrelse, materialevalg og eventuelle ændringer i konstruktionen. Sehested Tømrerfirma gennemgår derfor den konkrete bolig og afgrænser opgaven, før der skabes et brugbart grundlag for projektet."
      },
      {
        question: "Hvornår giver totalentreprise mening?",
        answer: "Totalentreprise kan være relevant ved en større ombygning, tilbygning eller renovering, hvor flere dele af byggeprojektet samles i én aftale. Hos Sehested Tømrerfirma bliver projektets indhold, organisering og ansvarsfordeling afklaret ud fra den konkrete bolig og skal fremgå af aftalen, før arbejdet begynder."
      },
      {
        question: "Hvad er vigtigt ved montering af døre og vinduer?",
        answer: "Præcise mål og omhyggelig tilpasning er afgørende, når døre og vinduer skal monteres. Sehested Tømrerfirma tilpasser arbejdet til boligens eksisterende forhold og har blandt andet erfaring med levering og montering af specialfremstillede vinduer fra Horn Vinduesfabrik i et konkret projekt."
      },
      {
        question: "Hvordan tilpasses tagarbejde og en træterrasse til boligen?",
        answer: "Ved tagarbejde vurderer Sehested Tømrerfirma den konkrete opgave og boligens eksisterende konstruktion, før løsningen fastlægges. En træterrasse planlægges ud fra hus, have og ønsket anvendelse, så mål, materialer og udformning tænkes sammen fra begyndelsen."
      },
      {
        question: "Hvad bør man oplyse til et tømrerfirma før projektstart?",
        answer: "Det er en fordel at beskrive boligen, planerne, prioriteringerne og de udfordringer, der skal løses. Sehested Tømrerfirma bruger oplysningerne til at drøfte muligheder, materialer, undersøgelser og afgrænsning, så forventningerne til tømrerarbejdet kan afstemmes fra begyndelsen."
      }
    ],
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvilket tømrerarbejde kan en erfaren tømrer hjælpe med?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Hos Sehested Tømrerfirma omfatter tømrerarbejde blandt andet ombygning, totalrenovering, tilbygning, totalentreprise, træterrasser, montering af døre og vinduer samt tagarbejde. Som tømrer i Mårslet hjælper Søren Sehested med både mindre opgaver og større boligprojekter."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan foregår et tømrerprojekt med en fast kontaktperson?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Når du vælger Sehested Tømrerfirma, er Søren Sehested både din faste kontakt og den udførende tømrermester fra start til slut. Det giver en direkte dialog om materialer, detaljer og ændringer undervejs og begrænser risikoen for misforståelser."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår giver en ombygning mening?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En ombygning kan være relevant, når boligen har plads nok, men rumfordelingen eller funktionerne ikke længere passer til hverdagen. Sehested Tømrerfirma hjælper med at konkretisere ønskerne og vurdere tømrerfagets del af eksempelvis en ændret rumfordeling, et køkken eller større forandringer i huset."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad påvirker prisen på en totalrenovering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prisen på en totalrenovering afhænger blandt andet af boligens stand, projektets størrelse, materialevalg og eventuelle ændringer i konstruktionen. Sehested Tømrerfirma gennemgår derfor den konkrete bolig og afgrænser opgaven, før der skabes et brugbart grundlag for projektet."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår giver totalentreprise mening?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Totalentreprise kan være relevant ved en større ombygning, tilbygning eller renovering, hvor flere dele af byggeprojektet samles i én aftale. Hos Sehested Tømrerfirma bliver projektets indhold, organisering og ansvarsfordeling afklaret ud fra den konkrete bolig og skal fremgå af aftalen, før arbejdet begynder."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad er vigtigt ved montering af døre og vinduer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Præcise mål og omhyggelig tilpasning er afgørende, når døre og vinduer skal monteres. Sehested Tømrerfirma tilpasser arbejdet til boligens eksisterende forhold og har blandt andet erfaring med levering og montering af specialfremstillede vinduer fra Horn Vinduesfabrik i et konkret projekt."
          }
        },
        {
          "@type": "Question",
          "name": "Hvordan tilpasses tagarbejde og en træterrasse til boligen?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Ved tagarbejde vurderer Sehested Tømrerfirma den konkrete opgave og boligens eksisterende konstruktion, før løsningen fastlægges. En træterrasse planlægges ud fra hus, have og ønsket anvendelse, så mål, materialer og udformning tænkes sammen fra begyndelsen."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad bør man oplyse til et tømrerfirma før projektstart?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Det er en fordel at beskrive boligen, planerne, prioriteringerne og de udfordringer, der skal løses. Sehested Tømrerfirma bruger oplysningerne til at drøfte muligheder, materialer, undersøgelser og afgrænsning, så forventningerne til tømrerarbejdet kan afstemmes fra begyndelsen."
          }
        }
      ]
    }
  },

  "toemrer-odder": {
    slug: "toemrer-odder",
    path: "/toemrer-odder",
    cityName: "Odder",
    seo: {
      title_tag: "Tømrer i Odder med over 20 års erfaring | Få et tilbud",
      meta_description: "Få en erfaren tømrer i Odder med over 20 års erfaring. Søren følger dit projekt fra start til slut, fra ombygning og totalrenovering til totalentreprise."
    },
    h1: "Tømrer i Odder til gennemtænkt tømrerarbejde",
    intro: "Søger du en tømrer i Odder, som tager personligt ansvar for arbejdet, hjælper jeg med både mindre opgaver og større boligprojekter. Jeg hedder Søren Sehested og har over 20 års erfaring. Mit tømrerfirma har base i Hasselager, og jeg kører blandt andet til kunder i Odder og omegn.",
    sections: [
      {
        h2: "Hvad kan mit tømrerfirma hjælpe med i Odder",
        paragraphs: [
          "Mit tømrerarbejde tager udgangspunkt i boligen og i den måde, du gerne vil bruge den på. Nogle kunder har brug for en ny træterrasse eller nye døre og vinduer, mens andre står foran en tilbygning, en ombygning eller en gennemgribende totalrenovering af huset.",
          "Ved døre og vinduer er præcis opmåling og montering afgørende for både udtryk og funktion. Jeg har blandt andet leveret og monteret specialfremstillede vinduer fra Horn Vinduesfabrik. Det er et konkret eksempel på, hvordan løsningen kan tilpasses bygningen og de eksisterende detaljer."
        ],
        list: [
          "Totalrenovering og ombygning af boliger",
          "Tilbygning og etablering af træterrasse",
          "Montering af døre og vinduer",
          "Tagarbejde på eksisterende boliger"
        ]
      },
      {
        h2: "Samme tømrermester følger arbejdet fra start til slut",
        paragraphs: [
          "Når du vælger mig som tømrermester, er det mig, du taler med om opgaven, og mig, der udfører arbejdet. Du skal derfor ikke forklare dine ønsker til skiftende kontaktpersoner. Det giver en enkel dialog og gør det lettere at holde fast i de beslutninger, vi træffer undervejs.",
          "Den personlige arbejdsform betyder også, at jeg har kendskab til både helheden og de små detaljer i dit projekt. Det gælder uanset, om opgaven består af afgrænset tømrerarbejde eller en større renovering, hvor flere dele af boligen skal fungere og passe sammen."
        ],
        subsections: [
          {
            h3: "Hvorfor er den direkte kontakt vigtig",
            paragraphs: [
              "Direkte dialog er især værdifuld, når eksisterende forhold kræver en tilpasset løsning. Der kan opstå spørgsmål om materialer, mål eller praktiske detaljer, når arbejdet går i gang. Her kan vi tale om mulighederne uden unødige mellemled og dermed mindske risikoen for misforståelser.",
              "Mine over 20 års erfaring med tømrerarbejde giver mig et solidt grundlag for at se muligheder og udfordringer i boligen. Jeg lægger vægt på, at løsningen ikke kun ser rigtig ud, men også passer til bygningens konstruktion, funktion og samlede udtryk."
            ]
          }
        ]
      },
      {
        h2: "Skal boligen have ombygning eller totalrenovering",
        paragraphs: [
          "En renovering opdaterer typisk boligens eksisterende funktioner, mens en ombygning ændrer indretningen eller den måde, arealet bliver brugt på. Ved en totalrenovering ses der bredere på huset. Det kan være relevant, når flere rum eller bygningsdele trænger til en samlet fornyelse.",
          "Hvis du overvejer ombygning, er det en fordel at tænke behov og helhed sammen fra begyndelsen. En ny rumfordeling, udskiftning af vinduer eller ændringer ved taget kan påvirke andre dele af boligen. Derfor bør materialer, funktion og eksisterende konstruktion vurderes i sammenhæng."
        ],
        subsections: [
          {
            h3: "Hvornår kan totalentreprise være relevant",
            paragraphs: [
              "Totalentreprise kan være relevant, når flere dele af et byggeprojekt skal tænkes sammen. Hos mig begynder dialogen med at afgrænse opgaven og finde ud af, hvad løsningen konkret skal omfatte. Ansvar, fagområder og praktiske rammer skal være tydelige, før arbejdet sættes i gang.",
              "Når du overvejer en totalentreprise i Odder, er det vigtigt at tale konkret om dine ønsker og boligens nuværende stand. Projektets omfang afgør, hvilken løsning der passer bedst. En grundig afklaring gør det samtidig lettere at prioritere de vigtigste dele af arbejdet."
            ]
          }
        ],
        list: [
          "Hvilke dele af boligen der skal ændres",
          "Hvilke materialer og hvilket udtryk du ønsker",
          "Hvad der skal bevares eller udskiftes",
          "Om projektet skal udføres som totalentreprise"
        ]
      },
      {
        h2: "Hvad afgør prisen på tømrerarbejde i Odder",
        paragraphs: [
          "Prisen på tømrerarbejde afhænger blandt andet af opgavens størrelse, materialevalg, adgangsforhold og boligens eksisterende konstruktion. En træterrasse vurderes anderledes end en ombygning eller totalrenovering. Derfor kræver en realistisk pris, at den konkrete opgave bliver afklaret.",
          "Har du brug for en erfaren tømrer i Odder, er du velkommen til at kontakte Sehested Tømrerfirma og fortælle om dit projekt. Du får direkte kontakt med mig, Søren Sehested, så vi kan tale om dine behov og finde frem til en løsning, der passer til boligen og opgavens omfang."
        ]
      }
    ],
    faq: [
      {
        question: "Hvilke opgaver kan et tømrerfirma hjælpe med?",
        answer: "Sehested Tømrerfirma udfører både mindre og større tømrerarbejde, herunder træterrasser, tilbygninger, tagarbejde, montering af døre og vinduer samt ombygning og totalrenovering. Søger du på tømrer Odder, kan Søren Sehested hjælpe med at tilpasse løsningen til boligens konstruktion, funktion og udtryk."
      },
      {
        question: "Hvad er forskellen på ombygning og totalrenovering?",
        answer: "En ombygning ændrer typisk boligens indretning eller den måde, arealet anvendes på. Ved en totalrenovering vurderes flere rum eller bygningsdele som en samlet helhed. Sehested Tømrerfirma hjælper med at afklare behov, materialer og eksisterende konstruktion, så de forskellige dele passer sammen."
      },
      {
        question: "Hvornår er totalentreprise relevant?",
        answer: "Totalentreprise kan være relevant, når flere dele af et byggeprojekt skal planlægges og tænkes sammen. Hos Sehested Tømrerfirma begynder processen med en konkret afgrænsning af opgaven, herunder hvilke dele der skal ændres, hvad der skal bevares, materialevalg samt projektets ansvar og praktiske rammer."
      },
      {
        question: "Hvad koster tømrerarbejde?",
        answer: "Prisen på tømrerarbejde afhænger blandt andet af opgavens størrelse, materialevalg, adgangsforhold og boligens eksisterende konstruktion. En træterrasse vurderes eksempelvis anderledes end en større ombygning eller totalrenovering. Sehested Tømrerfirma afklarer derfor den konkrete opgave, før der kan gives en realistisk pris."
      },
      {
        question: "Hvorfor vælge en tømrermester, der følger projektet fra start til slut?",
        answer: "Når den samme tømrermester står for både dialog og udførelse, bliver det lettere at fastholde aftaler og håndtere spørgsmål om mål, materialer og praktiske detaljer. Hos Sehested Tømrerfirma følger Søren Sehested selv arbejdet fra start til slut og trækker på over 20 års erfaring som tømrer."
      },
      {
        question: "Hvad er vigtigt ved montering af døre og vinduer?",
        answer: "Præcis opmåling og korrekt montering er afgørende for både funktion og det færdige udtryk. Sehested Tømrerfirma tilpasser løsningen til bygningen og de eksisterende detaljer og har blandt andet erfaring med levering og montering af specialfremstillede vinduer fra Horn Vinduesfabrik."
      }
    ],
    schema_markup: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Hvilke opgaver kan et tømrerfirma hjælpe med?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Sehested Tømrerfirma udfører både mindre og større tømrerarbejde, herunder træterrasser, tilbygninger, tagarbejde, montering af døre og vinduer samt ombygning og totalrenovering. Søger du på tømrer Odder, kan Søren Sehested hjælpe med at tilpasse løsningen til boligens konstruktion, funktion og udtryk."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad er forskellen på ombygning og totalrenovering?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "En ombygning ændrer typisk boligens indretning eller den måde, arealet anvendes på. Ved en totalrenovering vurderes flere rum eller bygningsdele som en samlet helhed. Sehested Tømrerfirma hjælper med at afklare behov, materialer og eksisterende konstruktion, så de forskellige dele passer sammen."
          }
        },
        {
          "@type": "Question",
          "name": "Hvornår er totalentreprise relevant?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Totalentreprise kan være relevant, når flere dele af et byggeprojekt skal planlægges og tænkes sammen. Hos Sehested Tømrerfirma begynder processen med en konkret afgrænsning af opgaven, herunder hvilke dele der skal ændres, hvad der skal bevares, materialevalg samt projektets ansvar og praktiske rammer."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad koster tømrerarbejde?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Prisen på tømrerarbejde afhænger blandt andet af opgavens størrelse, materialevalg, adgangsforhold og boligens eksisterende konstruktion. En træterrasse vurderes eksempelvis anderledes end en større ombygning eller totalrenovering. Sehested Tømrerfirma afklarer derfor den konkrete opgave, før der kan gives en realistisk pris."
          }
        },
        {
          "@type": "Question",
          "name": "Hvorfor vælge en tømrermester, der følger projektet fra start til slut?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Når den samme tømrermester står for både dialog og udførelse, bliver det lettere at fastholde aftaler og håndtere spørgsmål om mål, materialer og praktiske detaljer. Hos Sehested Tømrerfirma følger Søren Sehested selv arbejdet fra start til slut og trækker på over 20 års erfaring som tømrer."
          }
        },
        {
          "@type": "Question",
          "name": "Hvad er vigtigt ved montering af døre og vinduer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Præcis opmåling og korrekt montering er afgørende for både funktion og det færdige udtryk. Sehested Tømrerfirma tilpasser løsningen til bygningen og de eksisterende detaljer og har blandt andet erfaring med levering og montering af specialfremstillede vinduer fra Horn Vinduesfabrik."
          }
        }
      ]
    }
  }
};
